module.exports = __webpack_public_path__ + "img/news-slider2-ja.f62fa422.jpg";